var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 27,
    viewBox: "0 0 25 27",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.893229 1.90621L3 12.7416L0.869282 24.7948C0.722096 25.6274 1.61047 26.2556 2.3464 25.8393L23.8874 13.6532C24.5798 13.2615 24.5598 12.2574 23.8523 11.8936L2.33219 0.82606C1.5897 0.444205 0.733873 1.08662 0.893229 1.90621Z",
    fill: "#DE9C4E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 12.7416H13M3 12.7416L0.893229 1.90621C0.733873 1.08662 1.5897 0.444205 2.33219 0.82606L23.8523 11.8936C24.5598 12.2574 24.5798 13.2615 23.8874 13.6532L2.3464 25.8393C1.61047 26.2556 0.722096 25.6274 0.869282 24.7948L3 12.7416Z",
    stroke: "#EFEFEF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default __webpack_public_path__ + "static/media/send.64957c30.svg";
export { SvgComponent as ReactComponent };